// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1-p3P","alert":"SettungsInbox_alert__12-F9"};